import { useId } from 'react';
import type { CustomIconProps } from '../types';

const Email = ({ width, height, color, dataTestId, ...props }: CustomIconProps): JSX.Element => {
    const id = useId();
    const maskId = `email-mask-${id}`;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ?? '16'}
            height={height ?? '13'}
            viewBox="0 0 16 13"
            fill="none"
            data-testid={dataTestId}
            {...props}
        >
            <mask id={maskId} fill="white">
                <rect y="0.0666504" width="16" height="12" rx="1" />
            </mask>
            <rect
                y="0.0666504"
                width="16"
                height="12"
                rx="1"
                fill="white"
                stroke={color ?? '#414042'}
                strokeWidth="3"
                mask={`url(#${maskId})`}
            />
            <path
                d="M0.5 0.56665L7.34507 6.49904C7.72093 6.82479 8.27907 6.82479 8.65493 6.49904L15.5 0.56665"
                stroke={color ?? '#414042'}
                strokeWidth="1.5"
            />
        </svg>
    );
};

export default Email;
